import React from "react";
import { projects } from "data";
import ProjectDetails from "../ProjectDetails";

const Bison = React.forwardRef((props, ref) => {
  const bisonData = projects.find(project => project.name === 'Bison Finance');

  return (
    <div ref={ref}>
      <ProjectDetails project={bisonData} />
    </div>
  )
});

Bison.displayName = "Bison";

export default Bison;